import { render, staticRenderFns } from "./ProductList.vue?vue&type=template&id=43c74e01&"
import script from "./ProductList.ts?vue&type=script&lang=js&"
export * from "./ProductList.ts?vue&type=script&lang=js&"
import style0 from "./ProductList.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports